import { Injectable } from '@angular/core';
import {
  DemoComplexConditions,
  DemoConditionalsFieldsDict,
  DemoOperatorsDict,
  DemoStateDefinition,
  DemoTemplateDict,
} from '@demo/data/demo-complex-conditions';
import { ComplexConditionsListService } from '@module-definition/complex-conditions/complex-conditions-list/complex-conditions-list.service';
import { delay, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DemoComplexConditionsService extends ComplexConditionsListService {
  getConditionalTransitions(transitionId: number) {
    return of(DemoComplexConditions).pipe(delay(100));
  }

  getOperatorsDict() {
    return of(DemoOperatorsDict).pipe(delay(100));
  }

  getConditionalsFieldsDict() {
    return of(DemoConditionalsFieldsDict).pipe(delay(100));
  }

  getStateDefinition(workflowId: number, showDeleted?: boolean) {
    return of(DemoStateDefinition).pipe(delay(100));
  }

  getTemplateDict(entityId: number, screenId: number) {
    return of(DemoTemplateDict).pipe(delay(100));
  }

  getConditionals(id: number) {
    return of(DemoComplexConditions).pipe(delay(100));
  }
}
